var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c("gg-input-label", [_vm._v("RAW Record")]),
      _c("v-textarea", {
        attrs: {
          outlined: "",
          dense: "",
          name: "RAW Record",
          rows: "3"
        },
        model: {
          value: _vm.model.txtdata,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "txtdata", $$v)
          },
          expression: "model.txtdata"
        }
      }),
      _c("gg-text-field", {
        attrs: {
          label: "Name",
          name: "Name",
          placeholder: "Valid zone name",
          disabled: ""
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.name,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "name", $$v)
          },
          expression: "model.name"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.ttl,
            expression: "rules.ttl"
          }
        ],
        attrs: {
          label: "TTL",
          name: "TTL",
          placeholder: "14400",
          "error-messages": _vm.errors.collect("TTL")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.ttl,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "ttl", $$v)
          },
          expression: "model.ttl"
        }
      }),
      _c("label", [_vm._v("Policy")]),
      _c(
        "v-radio-group",
        {
          staticClass: "mt-1",
          attrs: {
            row: "",
            "hide-details": ""
          },
          model: {
            value: _vm.model_for_record.p,
            callback: function callback($$v) {
              _vm.$set(_vm.model_for_record, "p", $$v)
            },
            expression: "model_for_record.p"
          }
        },
        [
          _c("v-radio", {
            attrs: {
              color: "primary",
              label: "None",
              value: "none"
            }
          }),
          _c("v-radio", {
            attrs: {
              color: "primary",
              label: "Quarantine",
              value: "quarantine"
            }
          }),
          _c("v-radio", {
            attrs: {
              color: "primary",
              label: "Reject",
              value: "reject"
            }
          })
        ],
        1
      ),
      _c("v-switch", {
        attrs: {
          label: "Optional parameters",
          color: "primary"
        },
        model: {
          value: _vm.optional,
          callback: function callback($$v) {
            _vm.optional = $$v
          },
          expression: "optional"
        }
      }),
      _c("v-slide-y-transition", [
        _vm.optional
          ? _c(
              "div",
              [
                _c("label", [_vm._v("Subdomain policy")]),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-1",
                    attrs: {
                      row: "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.model_for_record.sp,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model_for_record, "sp", $$v)
                      },
                      expression: "model_for_record.sp"
                    }
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        color: "primary",
                        label: "None",
                        value: "none"
                      }
                    }),
                    _c("v-radio", {
                      attrs: {
                        color: "primary",
                        label: "Quarantine",
                        value: "quarantine"
                      }
                    }),
                    _c("v-radio", {
                      attrs: {
                        color: "primary",
                        label: "Reject",
                        value: "reject"
                      }
                    })
                  ],
                  1
                ),
                _c("label", [_vm._v("DKIM mode")]),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-1",
                    attrs: {
                      row: "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.model_for_record.adkim,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model_for_record, "adkim", $$v)
                      },
                      expression: "model_for_record.adkim"
                    }
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        color: "primary",
                        label: "Relaxed",
                        value: "r"
                      }
                    }),
                    _c("v-radio", {
                      attrs: {
                        color: "primary",
                        label: "Strict",
                        value: "s"
                      }
                    })
                  ],
                  1
                ),
                _c("label", [_vm._v("SPF mode")]),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-1",
                    attrs: {
                      row: "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.model_for_record.aspf,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model_for_record, "aspf", $$v)
                      },
                      expression: "model_for_record.aspf"
                    }
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        color: "primary",
                        label: "Relaxed",
                        value: "r"
                      }
                    }),
                    _c("v-radio", {
                      attrs: {
                        color: "primary",
                        label: "Strict",
                        value: "s"
                      }
                    })
                  ],
                  1
                ),
                _c("gg-text-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rules.percentage,
                      expression: "rules.percentage"
                    }
                  ],
                  attrs: {
                    label: "Percentage",
                    name: "Percentage",
                    type: "number",
                    min: "0",
                    max: "100",
                    "error-messages": _vm.errors.collect("Percentage")
                  },
                  model: {
                    value: _vm.model_for_record.pct,
                    callback: function callback($$v) {
                      _vm.$set(_vm.model_for_record, "pct", $$v)
                    },
                    expression: "model_for_record.pct"
                  }
                }),
                _c("label", [_vm._v("Generate failure reports when")]),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-1",
                    attrs: {
                      row: "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.model_for_record.fo,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model_for_record, "fo", $$v)
                      },
                      expression: "model_for_record.fo"
                    }
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        color: "green",
                        label: "All checks fail",
                        value: "0"
                      }
                    }),
                    _c("v-radio", {
                      attrs: {
                        color: "green",
                        label: "Any check fails",
                        value: "1"
                      }
                    })
                  ],
                  1
                ),
                _c("label", [_vm._v("Report format")]),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-1",
                    attrs: {
                      row: "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.model_for_record.rf,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model_for_record, "rf", $$v)
                      },
                      expression: "model_for_record.rf"
                    }
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        color: "green",
                        label: "AFRF",
                        value: "afrf"
                      }
                    }),
                    _c("v-radio", {
                      attrs: {
                        color: "green",
                        label: "IODEF",
                        value: "iodef"
                      }
                    })
                  ],
                  1
                ),
                _c("gg-text-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rules.interval,
                      expression: "rules.interval"
                    }
                  ],
                  attrs: {
                    label: "Report interval",
                    name: "Report interval",
                    type: "number",
                    "error-messages": _vm.errors.collect("Report interval")
                  },
                  model: {
                    value: _vm.model_for_record.ri,
                    callback: function callback($$v) {
                      _vm.$set(_vm.model_for_record, "ri", $$v)
                    },
                    expression: "model_for_record.ri"
                  }
                }),
                _c("gg-input-label", [_vm._v("URI")]),
                _c("v-textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rules.rua,
                      expression: "rules.rua"
                    }
                  ],
                  staticClass: "gg-input",
                  attrs: {
                    outlined: "",
                    dense: "",
                    name: "URI",
                    rows: "1",
                    placeholder: "Comma-delimited mailto URIs",
                    hint: "Send aggregate mail reports to",
                    "persistent-hint": "",
                    "error-messages": _vm.errors.collect("URI")
                  },
                  model: {
                    value: _vm.model_for_record.rua,
                    callback: function callback($$v) {
                      _vm.$set(_vm.model_for_record, "rua", $$v)
                    },
                    expression: "model_for_record.rua"
                  }
                }),
                _c("gg-input-label", [_vm._v("URI")]),
                _c("v-textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rules.ruf,
                      expression: "rules.ruf"
                    }
                  ],
                  staticClass: "gg-input",
                  attrs: {
                    outlined: "",
                    dense: "",
                    name: "ruf",
                    rows: "1",
                    placeholder: "Comma-delimited mailto URIs",
                    hint: "Send failure reports to",
                    "persistent-hint": "",
                    "data-vv-as": "URI",
                    "error-messages": _vm.errors.collect("ruf")
                  },
                  model: {
                    value: _vm.model_for_record.ruf,
                    callback: function callback($$v) {
                      _vm.$set(_vm.model_for_record, "ruf", $$v)
                    },
                    expression: "model_for_record.ruf"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }